import React from 'react';

const BaseSingleValue = ({ value, label }) => <span key={value}>{label}</span>;

export default BaseSingleValue;
